export default __webpack_public_path__ + "static/media/cif-bf.372312d4.svg";